import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Provider, connect } from 'react-redux'
import 'focus-visible'

import moment from 'moment-timezone'
import services from 'services'
import { ModalRoot } from 'components/styled/modal/modal-root'
import { toggleNavigationMenu, removeMessage } from 'actions'
import { mapLanguageToMoment } from 'i18n'
import './app.less'
import { AlertList } from 'components/styled/alert/alert-list'
import { AlertContextProvider } from 'components/styled/alert/context'
import {
  ALL_MARKETING_SERVICES,
  CookieContextProvider,
} from 'components/styled/cookie-consent/context'
import { AnalyticsService } from 'analytics/performance'
import { Intercom } from 'chat-bots/intercom'
import { IFRAME_VIEW_PATH, EMBEDDED_INTERVIEW_PATH } from 'app-constants'
import ThemeProvider from './theme/ThemeProvider'
import hideLoadingWrapper from './utils/hide-loading-wrapper'
import LanguageListener from './components/language-listener/language-listener'
import { PopoverRoot } from 'components/styled/popover/popover-root'
import { path } from 'lodash/fp'

export class AppComponent extends Component {
  constructor(props) {
    super(props)
    const { language, store } = props
    services.setStore(store)
    // Remove ordinal character from italian and spanish dates
    // (Doesn't work right if locale is set just once)
    moment.locale(mapLanguageToMoment(language))
    moment.locale(
      mapLanguageToMoment(language),
      language === 'it' || language === 'es' ? { ordinal: '%d' } : undefined
    )
    hideLoadingWrapper()

    // eslint-disable-next-line no-console,no-unused-expressions
    console &&
      'info' in console &&
      console.info(
        'Kiinnostaako Recrightin koodi? Jos koet osaavasi koodata ja olet kiinnostunut koodamaan videorekrytointisoftaa, ota yhteyttä careers@recright.com'
      )
  }

  onClick() {
    const { dispatch, navigationMenu } = this.props
    if (navigationMenu) {
      dispatch(toggleNavigationMenu(navigationMenu))
    }
  }

  getClassName() {
    const { language } = this.props
    if (language === 'zh') {
      return 'font-china'
    }
    if (language === 'ja') {
      return 'font-japanese'
    }
    return ''
  }

  renderSupport() {
    const { routing, showIntercom, language, user, actionBarHeight } =
      this.props
    const pathname =
      routing &&
      routing.locationBeforeTransitions &&
      routing.locationBeforeTransitions.pathname

    const isLiveInterviewPath =
      pathname &&
      (pathname.includes('/live-interview/') || pathname.includes('recordings'))

    const renderSupport = !(
      pathname &&
      (pathname.includes(IFRAME_VIEW_PATH) ||
        pathname.includes(EMBEDDED_INTERVIEW_PATH) ||
        isLiveInterviewPath)
    )
    if (!renderSupport) {
      return null
    }
    return (
      <Intercom
        pathname={pathname}
        language={language}
        showIntercom={showIntercom}
        currentUser={user}
        actionBarHeight={actionBarHeight}
      />
    )
  }

  render() {
    const { store, children, language, dispatch, messages } = this.props
    const className = this.getClassName()

    return (
      <div>
        <LanguageListener lang={language} />
        <Provider store={store}>
          <CookieContextProvider
            enabledAnalytics={[AnalyticsService.Amplitude]}
            enabledMarketing={ALL_MARKETING_SERVICES}
          >
            <ThemeProvider useGlobalStyle>
              <div onClick={() => this.onClick()} className={className}>
                <div>
                  {this.renderSupport()}
                  <AlertContextProvider>
                    <div>{children}</div>
                    {/* TODO move this to app content so that it will inherit correct theme? */}
                    <AlertList
                      messages={messages}
                      closeAfterTimeout
                      removeMessage={messageId =>
                        dispatch(removeMessage(messageId))
                      }
                    />
                  </AlertContextProvider>
                </div>
                <PopoverRoot />
                <ModalRoot />
              </div>
            </ThemeProvider>
          </CookieContextProvider>
        </Provider>
      </div>
    )
  }
}

AppComponent.propTypes = {
  store: PropTypes.shape({}).isRequired,
  language: PropTypes.string.isRequired,
  navigationMenu: PropTypes.string,
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
  showIntercom: PropTypes.bool,
  user: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
  }),
  messages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  actionBarHeight: PropTypes.number,
}

AppComponent.defaultProps = {
  navigationMenu: null,
  children: null,
  showIntercom: false,
  user: undefined,
  actionBarHeight: 0,
}

export default connect(state => ({
  language: state.global.language,
  showIntercom: state.global.showIntercom,
  navigationMenu: state.global.navigationMenu,
  routing: state.routing,
  user: state.global.session.user,
  messages: state.global.messages,
  actionBarHeight: state.global.actionBarHeight,
}))(AppComponent)
